
























import {Component, Prop, Vue} from 'vue-property-decorator'
import {uniqueId} from "@/util/uniqueId";

@Component
export default class TextInput extends Vue {
    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: true
    })
    showRequiredState!: boolean;

    @Prop({
        default: ''
    })
    placeholder!: string;

    @Prop({
        default: 1000
    })
    maxLength!: number;

    @Prop({
        default: true
    })
    isEditable!: boolean;

    @Prop({
        default: null
    })
    tooltip?: string | null;

    @Prop()
    name?: string;

    @Prop()
    label!: string;

    @Prop()
    error?: string | null;

    @Prop()
    value!: string | null;

    private updateValue(event: InputEvent) {
        const target = event.target as HTMLInputElement;
        this.$emit('input', target.value);
    }

    private uid = uniqueId();
}
